import { ENV } from "cortex/ui/src/constant/app";

/*
 * Will only log in non-prod deployment targets.
 */
export function devLogger(
  logger: (...args: unknown[]) => void,
  ...message: unknown[]
): void {
  if (ENV.DEPLOY_TARGET === "production") {
    return;
  }

  logger(...message);
}
